const RANK_MARKER = /\s(subsp\.|var\.|f\.)\s/;
/**
 * Renders a scientific name with only the actual name words in italics -
 * the author citation, and an infraspecific rank marker (subsp./var./f.)
 * when there is one, both stay upright (standard taxonomic convention) -
 * e.g. *Boletus edulis* var. *betulicola* Vassilkov, not the whole thing
 * italicized.
 *
 * The marker, when present, is expected already spliced into
 * canonicalName by the backend (Species::insertRankMarker() - GBIF's own
 * canonicalName never includes it, only scientificName does, and not
 * where it could just be reused as-is - see that method's docblock), so
 * it only needs pulling back out here into its own non-italic span.
 *
 * `canonicalName`/`author` are separate GBIF fields; `scientificName` is
 * GBIF's own combination of the two and can't be split apart reliably, so
 * it's only used as a fallback for the (rare) cases where canonicalName is
 * blank - in which case the author isn't repeated separately since it's
 * already baked into that string.
 */
export default function speciesName(s, _temp) {
  let {
    authorPrefix = ' '
  } = _temp === void 0 ? {} : _temp;
  if (s.canonicalName) {
    const markerMatch = s.canonicalName.match(RANK_MARKER);
    const name = markerMatch ? m("span", null, m("em", null, s.canonicalName.slice(0, markerMatch.index)), " ", markerMatch[1], ' ', m("em", null, s.canonicalName.slice(markerMatch.index + markerMatch[0].length))) : m("em", null, s.canonicalName);
    return m("span", null, name, s.author && m("small", null, authorPrefix + s.author));
  }
  return m("em", null, s.scientificName);
}

/**
 * speciesName() plus, when present, its synonymCanonicalName/synonymAuthor
 * pair rendered as "(= <synonym name>)" straight after - "<i>Accepted
 * name</i> Author (= <i>Synonym name</i> Author)", the exact format
 * SpeciesLabel.js already uses next to a tagged discussion/post. Shared
 * here so SpeciesAssignModal.js can show a species being assigned exactly
 * as it will actually be displayed once saved, rather than just its
 * accepted name with no indication a synonym was involved.
 */
export function speciesNameWithSynonym(s, _temp2) {
  let {
    authorPrefix = ' '
  } = _temp2 === void 0 ? {} : _temp2;
  return m("span", null, speciesName(s, {
    authorPrefix
  }), s.synonymCanonicalName && m("small", null, ' ', "(=", ' ', speciesName({
    canonicalName: s.synonymCanonicalName,
    author: s.synonymAuthor,
    scientificName: s.synonymCanonicalName
  }, {
    authorPrefix
  }), ")"));
}
flarum.reg.add('champis-species', 'forum/utils/speciesName', speciesName);